import { MapUtils } from '../../../utility/map-utils.js';
import { BusinessModuleRef } from '../business-module-ref.js';
import { SeatSelectionSerializer } from '../../../serialization/seat-selection-serializer.js';
import {
  ISeatSelectionEntry,
} from './seat-selection-entry.js';
import {
  DataModel, DataModelBuilder, SerializationContext, SerializedData,
  isSameData, isSameList, cloneListOfCloneable,
} from '../../dto/dto.js';

export class EventSeatSelectionLock extends DataModel {
  static readonly TYPE_ID: string = 'f010766de7bf43a0b654094a9118b1e2';

  constructor(
    public readonly eventId: string,
    public readonly businessRef: BusinessModuleRef,
    public readonly entries: ISeatSelectionEntry[],
  ) {
    super();
  }

  get $typeId(): string {
    return EventSeatSelectionLock.TYPE_ID;
  }

  static empty(businessRef: BusinessModuleRef, eventId: string): EventSeatSelectionLock {
    return new EventSeatSelectionLock(
        eventId,
        businessRef,
        []
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): EventSeatSelectionLock {
    return new EventSeatSelectionLock(
        MapUtils.get<string>(map, 'eventId'),
        BusinessModuleRef.mustDecode(MapUtils.get<string>(map, 'businessRef')),
        SeatSelectionSerializer.deserialize(context.fromBinaryBlob(MapUtils.getRaw(map, 'entries'))),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'eventId': this.eventId,
      'businessRef': this.businessRef.encode(),
      'entries': context.toBinaryBlob(SeatSelectionSerializer.serialize(this.entries)),
    };
  }

  clone(): this {
    return new EventSeatSelectionLock(
        this.eventId,
        this.businessRef.clone(),
        cloneListOfCloneable(this.entries),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.eventId === this.eventId &&
          isSameList(other.entries, this.entries, isSameData) &&
          isSameData(other.businessRef, this.businessRef);
  }
}

export class EventSeatSelectionLockBuilder extends DataModelBuilder<EventSeatSelectionLock> {
  build(context: SerializationContext, map: SerializedData): EventSeatSelectionLock {
    return EventSeatSelectionLock.fromMap(context, map);
  }
}
